import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import PropTypes from "prop-types";

const AddPartnerModal = ({
  show,
  handleClose,
  handleAddPartner,
  newPartner,
  setNewPartner,
  loading,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="add-partner-modal"
    >
      <Modal.Header closeButton className="add-partner-modal__header">
        <div>
          <p className="eyebrow mb-1 text-muted">Новый участник</p>
          <Modal.Title>Добавление партнёра</Modal.Title>
        </div>
        <span className="chip chip-ghost">2 минуты</span>
      </Modal.Header>
      <Modal.Body>
        <div className="add-partner-brief mb-3">
          <p>Укажите основные данные и мы сгенерируем карточку партнёра.</p>
        </div>
        <Form className="add-partner-grid">
          <Form.Group controlId="name">
            <Form.Label>Имя</Form.Label>
            <Form.Control
              type="text"
              placeholder="Например, Иван Петров"
              value={newPartner.name}
              onChange={(e) =>
                setNewPartner({ ...newPartner, name: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="promo_code">
            <Form.Label>Промокод</Form.Label>
            <Form.Control
              type="text"
              placeholder="VISAXXX"
              value={newPartner.promo_code}
              onChange={(e) =>
                setNewPartner({ ...newPartner, promo_code: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="partner@email.com"
              value={newPartner.email}
              onChange={(e) =>
                setNewPartner({ ...newPartner, email: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="phone">
            <Form.Label>Телефон</Form.Label>
            <Form.Control
              type="tel"
              placeholder="+34 600 000 000"
              value={newPartner.phone}
              onChange={(e) =>
                setNewPartner({ ...newPartner, phone: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="address" className="add-partner-grid__wide">
            <Form.Label>Адрес</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Город, улица, дом"
              value={newPartner.address}
              onChange={(e) =>
                setNewPartner({ ...newPartner, address: e.target.value })
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="add-partner-modal__footer">
        <div className="add-partner-hint">
          Все поля обязательны к заполнению
        </div>
        <div className="add-partner-actions">
          <Button variant="link" className="btn-ghost" onClick={handleClose}>
            Отмена
          </Button>
          <Button
            variant="primary"
            className="btn-rounded"
            onClick={handleAddPartner}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Сохраняем…
              </>
            ) : (
              "Сохранить партнёра"
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

AddPartnerModal.propTypes = {
  show: PropTypes.bool.isRequired, // Булево значение (true/false)
  handleClose: PropTypes.func.isRequired, // Функция закрытия модального окна
  handleAddPartner: PropTypes.func.isRequired, // Функция добавления партнера
  newPartner: PropTypes.shape({
    name: PropTypes.string.isRequired,
    promo_code: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.string,
  }).isRequired, // Объект партнера
  setNewPartner: PropTypes.func.isRequired, // Функция изменения данных партнера
  loading: PropTypes.bool.isRequired, // Флаг загрузки
};
export default AddPartnerModal;
